import { bookLoaded } from "../../books/action";

const featuredFilter = (status) =>{
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books");
    const books = await response.json();
  
    const filterFeature = books.filter((book) => book?.featured);
  
    dispatch(bookLoaded(filterFeature, status));
  };
}

export default featuredFilter;
